import { render } from "./MatrixDataSection.vue?vue&type=template&id=4f65820a&scoped=true"
import script from "./MatrixDataSection.vue?vue&type=script&lang=js"
export * from "./MatrixDataSection.vue?vue&type=script&lang=js"

import "./MatrixDataSection.vue?vue&type=style&index=0&id=4f65820a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f65820a"]])

export default __exports__